import { WeekView } from "@devexpress/dx-react-scheduler-material-ui"
import calendarStyles from "../../../styles/EventsCalendarStyles"
import { Box } from "@mui/material"
import { useTheme } from '@mui/material/styles'

export const TimeTableCell = ({ currentTimeIndicatorPosition, isShaded, ...restProps }: any) => {
  const theme = useTheme()
  const classes = calendarStyles(theme, { shadedHeight: currentTimeIndicatorPosition })
  const isNow = !!currentTimeIndicatorPosition

  return (
    <WeekView.TimeTableCell
      isShaded={isShaded && !isNow}
      currentTimeIndicatorPosition={currentTimeIndicatorPosition}
      sx={isShaded && !isNow ? classes.shadedCell : undefined}
      {...restProps}
    >
      {isNow && isShaded && <Box sx={classes.shadedPart} />}
    </WeekView.TimeTableCell>
  )
}